module.exports = __webpack_public_path__ + "img/icon_submenu11.30e2415a.svg";